function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><rect fill="#EFC036" width="56" height="56" rx="28" /><path d="M26.867 31l-.86 6.876c-.123.99 1.122 1.531 1.761.764l10-12A1 1 0 0 0 37 25h-7.867l.86-6.876c.123-.99-1.122-1.531-1.761-.764l-10 12A1 1 0 0 0 19 31h7.867zm.718-9.74l-.577 4.616A1 1 0 0 0 28 27h6.865l-6.45 7.74.577-4.616A1 1 0 0 0 28 29h-6.865l6.45-7.74z" fill="#FFF" fillRule="nonzero" /></g></svg>;
});